module.exports = __webpack_public_path__ + "static/media/ZGAO-online-shop-for-vintage-design-furniture-lighting-and-accessories.e057c852.svg";